import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import {mapDefaultOpts} from "./staticvariables";

// TODOS
// 4. Add heatmap layer as hook with (get, add, updateData, remove, updateHeatmapLayer)

const useMap = (ref) => {

    const [mapRef, setMapRef] = useState(ref);
    const [mapLoaded, setMapLoaded] = useState(false);
    
    useEffect(() => {
        setMapRef(ref)
    }, [ref])

    /**
     * Init map.
     *
     * @param {Object} mapOpts - Options for the initializing map.
     * @param {String} mapOpts.token - Access token.
     * @param {import('react').Ref} mapOpts.containerRef - Container ref for the  map.
     * @param {String} mapOpts.style - Map style for the map.
     * @param {Array} mapOpts.center - Set center focus for the map.
     * @param {Number} mapOpts.zoom - Set zoom for the map.
     *
    */
    const initMap = (mapOpts) => {
        if (mapRef.current) return; // initialize map only once

        mapboxgl.accessToken = mapOpts.token;
        mapRef.current = new mapboxgl.Map({
            container: mapOpts.containerRef || mapDefaultOpts.containerRef,
            style: mapOpts.style || mapDefaultOpts.style,
            center: mapOpts.center || mapDefaultOpts.center,
            zoom: mapOpts.zoom || mapDefaultOpts.zoom
        });
        mapRef.current.on('load', () => {
            setMapLoaded(true);
        });
    }

    /**
     * Add source.
     *
     * @param {import('mapbox-gl').Source} obj - Object for the adding source in mapbox-gl API.
     *
    */
    const addSource = (id, obj) => {
        let source = getSource(id);
        if (source) throw new Error("Source already exists")
        mapRef.current.addSource(id, obj)
    }

    /**
     * Get source.
     * @param {String} id - Source ID.
    */
    const getSource = (id) => {
        return mapRef.current.getSource(id)
    }

    /**
     * Update source.
     * @param {String} id - Source ID.
     * @param {Object} newData - New Source data.
    */
    const updateSource = (id, newData) => {
        const source = mapRef.current.getSource(id)
        source.setData(newData);
    }

    /**
     * Remove source.
     * @param {String} id - Source ID.
    */
    const removeSource = (id) => {
        mapRef.current.removeSource(id)
    }

    /**
     * Add layer.
     * @param {import('mapbox-gl').Layer} obj - Options for the adding layer in mapbox-gl API.
    */
    const addLayer = (obj) => {
        const layer = getLayer(obj.id);
        if (layer) throw new Error("Layer already exists");
        mapRef.current.addLayer(obj)
    }

    /**
     * Get layer.
     * @param {String} id - Layer ID.
    */
    const getLayer = (id) => {
        return mapRef.current.getLayer(id)
    }

    /**
     * Update layer.
     * @param {String} id - Layer ID.
     * @param {String} type - Layer type to update ("paint" & "layout").
     * @param {String} property - Property type to update.
     * @param {any} value - value to update.
    */
    const updateLayer = (id, type, property, value) => {
        if (type == "paint") mapRef.current.setPaintProperty(id, property, value)
        else mapRef.current.setLayoutProperty(id, property, value);
    }

    /**
     * Remove layer.
     * @param {String} id - Layer ID.
    */
    const removeLayer = (id) => {
        mapRef.current.removeLayer(id)
    }

    return {map: mapRef, mapLoaded, initMap, addSource, getSource, updateSource, removeSource,
        addLayer, getLayer, updateLayer, removeLayer}
}

export default useMap